import { useNavigate } from "react-router-dom"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"
import { apiRoute, ENUM_APP_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, funValidateNoInput, getModMandatory, getModVisiblity, linksUrl } from "../../constants/enum";
import { useEffect, useRef, useState } from "react";
import { Card, Select, Autocomplete, AutocompleteItem, Button, SelectItem, Input, CardBody } from "@nextui-org/react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { isMobile } from 'react-device-detect';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faPlus, faSave, faTrash, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { useSelector } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import { Box } from "@mui/material";
import { isValid } from "date-fns";
import { orange } from "@mui/material/colors";

const ENUM_QTY_ON = [
    { value: "METER" },
    { value: "LOT" },
    { value: "TAKA" },
    { value: "SUT" },
    { value: "CHALLAN" }
]

const ENUM_UNIT = [
    { value: "PCS" },
    { value: "NOS" },
    { value: "BOX" },
    { value: "BTL" },
    { value: "PAK" },
    { value: "KIT" },
    { value: "MTR" },
    { value: "LTR" },
    { value: "SQF" },
    { value: "SQM" },
    { value: "KGS" },
    { value: "CRT" },
    { value: "TON" },
]
const CreateSalesOrder = () => {
    const navigate = useNavigate();
    const handleClickPrev = () => {
        navigate(linksUrl.transaction.salesOrderEntry.orderEntryMaster)
    }
    const [deletedItemRows, setDeletedItemRows] = useState([])
    const { compCode, appType, isMultipleCompany } = useSelector((state) => state.company)
    
    const { user } = useSelector((state) => state.auth);
    const { detailParams, isNewEntry } = useSelector((state) => state.saleOrderEntry)
    let [isOrdUpLock, setIsOrdUpLock] = useState(false)
    let [isOrdClose, setIsOrdClose] = useState(false)
    const [modeSettingParams, setModSettingParams] = useState()
    const gridContainerRef = useRef(null);
    const inputRef = useRef(null)

    const { isLoading: isLoadingData, isError: isErrorMastData, data: masterData = [] } = useFetchWithBody({
        url: apiRoute.transaction.salesOrderEntry.entryMasterData,
        queryKey: "fetchSalesMasterData",
        inputData: {
            compcode: compCode.join(",")
        }
    })


    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modeSetting.getModSetting,
        queryKey: "fetchModSetting",
        inputData: {
            mod_name: ENUM_MOD_NAME.SalesOrder
        }
    })

    const onSuccessTasks = (data) => {
        if (data)
            navigate(linksUrl.transaction.salesOrderEntry.orderEntryMaster)
    }
    const onSuccessOrdNo = (data) => {

        if (data && data.length > 0) {
            setFormData((prevData) => ({
                ...prevData,
                orderNo: data[0].new_ord_no,
            }))
        }
    }
    const { mutate: funGenOrderNo } = usePost({
        url: apiRoute.transaction.salesOrderEntry.generateOrderNo,
        queryKey: "GenerateOrderNo",
        onSuccessTasks: onSuccessOrdNo

    })

    const { isPending: isLoadingDetail, isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.transaction.salesOrderEntry.fetchOrderDetail,
        queryKey: "fetchOrderDetail",
    });

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
        if (isNewEntry) {
            funGenOrderNo({
                data: {
                    comp_code: compCode.join(','),
                    bill_type: 'S',
                    trade_of: 'C'
                }
            })
        }
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            const { compcode, orderno, billtype } = detailParams
            funGetDetail({
                data: {
                    comp_code: compcode,
                    order_no: orderno,
                    bill_type: billtype,

                }
            })
        }
    }, [])

    useEffect(() => {

        setModSettingParams({
            [RowsField.oChallan]: getModVisiblity(ENUM_MOD_PARAMETER.saleOrderEntry.Ochallan, modSetting),
            [RowsField.qtyPer]: getModVisiblity(ENUM_MOD_PARAMETER.saleOrderEntry.QtyOn, modSetting),
            [RowsField.packSize]: getModVisiblity(ENUM_MOD_PARAMETER.saleOrderEntry.PackSize, modSetting),
            [RowsField.compName]: getModVisiblity(ENUM_MOD_PARAMETER.saleOrderEntry.CompName, modSetting)
        })
    }, [modSetting])

    const { isPending, isError, mutate: funInUpSalesOrder } = usePost({
        url: apiRoute.transaction.salesOrderEntry.add_update,
        queryKey: "Inupsalesorder",
        onSuccessTasks

    })

    let gridData = []
    const [rows, setRows] = useState([])
    const RowsField = {
        id: "id",
        orderNo: "orderNo",
        srNo: "srNo",
        itemCode: "itemCode",
        designNo: "designNo",
        itemName: "itemName",
        compName: "compName",
        packSize: "packSize",
        itemDetail: "itemDetail",
        unit: "unit",
        rate: "rate",
        amount: "amount",
        discPer: "discPer",
        discAmt: "discAmt",
        pcs: "pcs",
        meter: "meter",
        weight: "weight",
        qtyPer: "qtyPer",
        oChallan: "oChallan",
        oMtrRange: "oMtrRange",
        // closeDate: "closeDate",
        stopDate: "stopDate",
        orderCloseDate: "orderCloseDate"

    }

    const initialRow = {
        [RowsField.orderNo]: "0",
        [RowsField.srNo]: 0,
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.designNo]: "",
        [RowsField.compName]: "",
        [RowsField.packSize]: "",
        [RowsField.itemDetail]: "",
        [RowsField.unit]: "",
        [RowsField.rate]: 0,
        [RowsField.amount]: 0,
        [RowsField.discPer]: 0,
        [RowsField.discAmt]: 0,
        [RowsField.pcs]: 0,
        [RowsField.meter]: 0,
        [RowsField.weight]: 0,
        [RowsField.stopDate]: null,
        [RowsField.orderCloseDate]: null,
        [RowsField.oChallan]: 0,
        [RowsField.oMtrRange]: 0,
        [RowsField.qtyPer]: ""
    }

    const handleDeleteRow = (delid) => {

        const updatedRows = rows.filter((row) => row.id !== delid)
        let DeletedRow = rows.filter((row) => row.id == delid)

        setRows(updatedRows)
        setDeletedItemRows([...deletedItemRows, ...DeletedRow])

    }
    const funCalAmount = (unit, meter = 0, weight = 0, pcs = 0, rate = 0) => {
        const u = unit?.toLowerCase() || "";
        const r = parseFloat(rate) || 0;

        switch (u) {
            case "mtr":
            case "ltr":
            case "sqf":
            case "sqm":
                return r * parseFloat(meter || 0);
            case "kgs":
            case "grm":
            case "crt":
            case "ton":
                return r * parseFloat(weight || 0);
            default:
                return r * parseFloat(pcs || 0);
        }
        // let Amount = 0;
        // let t_unit = unit && unit != "" ? unit.toLowerCase() : ""
        // if (t_unit != "") {
        //     if (t_unit == "mtr" || t_unit == "ltr") {
        //         Amount = parseFloat(rate) * parseFloat(meter)
        //     }
        //     else if (t_unit == "kgs" || t_unit == "grm")
        //         Amount = parseFloat(rate) * parseFloat(weight)
        //     else
        //         Amount = parseFloat(rate) * parseFloat(pcs)
        // }
        // else
        //     Amount = parseFloat(rate) * parseFloat(pcs)
        // return Amount;
    }
    // const handleInputChange = (rowid, e) => {
    //     const { value, id, name } = e.target;

    //     let isVallid = true
    //     if (id == RowsField.oMtrRange) {
    //         isVallid = funValidateNoInput(value)
    //         console.log(isVallid, "fg")
    //     }

    //     if (isValid==true) {
    //         const index = rows.findIndex((ele) => ele.id == rowid);
    //         if (index === -1) return;

    //         const newRows = [...rows];
    //         const currentRow = name == RowsField.unit ? { ...newRows[index], [name]: value } : { ...newRows[index], [id]: value };

    //         const {
    //             unit = "",
    //             rate = 0,
    //             weight = 0,
    //             meter = 0,
    //             pcs = 0,
    //             discPer = 0,
    //         } = currentRow;

    //         const amount = funCalAmount(unit, meter, weight, pcs, rate);
    //         currentRow.amount = amount;

    //         if (parseFloat(amount) > 0 && parseFloat(discPer) > 0) {
    //             currentRow.discAmt = ((amount * parseFloat(discPer)) / 100).toFixed(2);
    //         }

    //         newRows[index] = currentRow;
    //         setRows(newRows);
    //     }
    // };

    // const handleInputChange = (rowid, e) => {
    //     let { value, id } = e.target

    //     const index = rows.findIndex((ele) => ele.id == rowid)
    //     const newRows = [...rows]
    //     const t_unit = newRows[index].unit ? newRows[index].unit : ""
    //     let t_rate = newRows[index].rate ? newRows[index].rate : 0
    //     let t_weight = newRows[index].weight ? newRows[index].weight : 0
    //     let t_meter = newRows[index].meter ? newRows[index].meter : 0
    //     let t_pcs = newRows[index].pcs ? newRows[index].pcs : 0
    //     let t_discper = newRows[index].discPer ? newRows[index].discPer : 0
    //     let t_Amount = 0;
    //     if (id == RowsField.meter) {
    //         t_meter = value
    //     }
    //     else if (id == RowsField.weight) {
    //         t_weight = value
    //     }
    //     else if (id == RowsField.rate) {
    //         t_rate = value
    //     }
    //     else if (id == RowsField.pcs) {
    //         t_pcs = value
    //     }
    //     else if (id == RowsField.discPer) {
    //         t_discper = value
    //     }
    //     t_Amount = funCalAmount(t_unit, t_meter, t_weight, t_pcs, t_rate)


    //     newRows[index][id] = value
    //     //newRows[index].SrNo = 
    //     newRows[index].amount = t_Amount;
    //     if (parseFloat(t_Amount) > 0 && parseFloat(t_discper) > 0)
    //         newRows[index].discAmt = ((parseFloat(t_Amount) * parseFloat(t_discper)) / 100).toFixed(2)
    //     setRows(newRows)
    // }
    const handleInputChange = (rowId, e) => {
        const { value, id, name } = e.target;

        // Validate only when needed
        if (id === RowsField.oMtrRange && !funValidateNoInput(value)) {
            return;
        }

        setRows((prevRows) => {
            const index = prevRows.findIndex((row) => row.id === rowId);
            if (index === -1) return prevRows;

            const updatedRows = [...prevRows];

            // Update field dynamically
            const key = name === RowsField.unit ? name : id;

            const updatedRow = {
                ...updatedRows[index],
                [key]: value,
            };

            const {
                unit = "",
                rate = 0,
                weight = 0,
                meter = 0,
                pcs = 0,
                discPer = 0,
                oMtrRange = 0,
                oChallan = 0,
                qtyPer = ""
            } = updatedRow;

            // Calculate amount
            const amount = funCalAmount(unit, meter, weight, pcs, rate);
            updatedRow.amount = amount;
            const skipFields = new Set([RowsField.oMtrRange, RowsField.oChallan]);

            if (qtyPer === "CHALLAN") {
                const mtrRange = parseFloat(oMtrRange) || 0;
                const challan = parseFloat(oChallan) || 0;
                updatedRow.meter = (challan * mtrRange).toFixed(2);
            } else if (!skipFields.has(id)) {
                updatedRow.oMtrRange = "";
                updatedRow.oChallan = "";
            }
            // Calculate discount
            updatedRow.discAmt =
                amount > 0 && discPer > 0
                    ? ((amount * discPer) / 100).toFixed(2)
                    : 0;

            updatedRows[index] = updatedRow;

            return updatedRows;
        });
    };

    const [menuTrigger, setMenuTrigger] = useState("input");

    const renderInputCell = (row, input_id, input_type, is_readonly, holder_text, is_required, variant, color) => {

        return (
            <Input
                isRequired={is_required}
                id={RowsField[input_id]}
                type={input_type}
                size="sm"
                // label=""
                labelPlacement="outside"
                readOnly={isOrdClose ? true : is_readonly}
                placeholder={holder_text}
                //allow space in text box
                onKeyDown={(event) => {
                    if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                        return; // Do nothing
                    } else {
                        event.stopPropagation(); // Prevent other keys from propagating
                    }
                }}
                defaultValue=""
                value={row[input_id]}
                onChange={(e) => handleInputChange(row.id, e)}
                className="max-w-xs mt-1"
                variant={variant ? variant : "bordered"}
                color={color ? color : ""}
                onFocus={(e) => {
                    // Option 1: Clear only if value is zero
                    // if (e.target.value === '0') {
                    //     e.target.value = '';
                    // }

                    // Option 2: Select all text
                    e.target.select();
                }}

            ></Input>
        )
    }
    const itemGridHeadClass = "saleitem-grid-style"
    const handleDateChange = (newValue, index, name) => {

        const newRows = [...rows]
        const sDate = dayjs(newValue).format("YYYY-MM-DD");
        newRows[index][name] = sDate;
        setRows(newRows)

    }
    const handleSelectChange = (index, e) => {

        const { value, name } = e.target;
        const newRows = [...rows]
        newRows[index][name] = value;
        if (value === "CHALLAN") {
            const mtrRange = parseFloat(newRows[index][RowsField.oMtrRange]) || 0;
            const challan = parseFloat(newRows[index][RowsField.oChallan]) || 0;
            const meter = mtrRange * challan;
            newRows[index][RowsField.meter] = meter.toFixed(2);
        } else {
            newRows[index][RowsField.oMtrRange] = "";
            newRows[index][RowsField.oChallan] = "";
            newRows[index][RowsField.meter] = 0; // optional but safer
        }
        setRows(newRows)

    }
    const ValidateGrid = () => {
        //let no = 0
        if (appType == ENUM_APP_TYPE.TEXTTILE) {
            if (modeSettingParams.oChallan || modeSettingParams.qtyPer) {
                const req_QtyOn = getModMandatory(ENUM_MOD_PARAMETER.saleOrderEntry.QtyOn, modSetting)
                const req_Ochallan = getModMandatory(ENUM_MOD_PARAMETER.saleOrderEntry.Ochallan, modSetting)
                for (let i = 0; i < rows.length; i++) {
                    // no = i + 1
                    if ((req_QtyOn && (rows[i].qtyPer == "" || rows[i].qtyPer == "0")) ||
                        (req_Ochallan && (rows[i].qtyPer == 'CHALLAN' && (rows[i].oChallan <= 0 || rows[i].oChallan == "")))
                    ) {
                        return 1
                    }
                }
            }
        }
    }

    const handleOpenChange = (isOpen, trigger) => {
        // if (isOpen && trigger === "manual") {
        //     // Find the input inside the autocomplete
        //     const input = inputRef.current?.querySelector("input");
        //     input?.blur(); // ✅ Close keyboard
        // }
        if (isOpen && trigger === "manual") {
            // User clicked icon → close keyboard
            inputRef.current?.blur();
        }

    };
    const handleWrapperMouseDown = (e) => {
        const isClearButton = e.target.closest("[aria-label='Clear']");
        if (isClearButton) {

            return; // Let clear button work normally
        }
        const iconClicked = e.target.closest("[aria-label='Open menu']");
        if (iconClicked) {
            setMenuTrigger("manual");
        } else {
            setMenuTrigger("input");
        }
    };
    const columns = [
        {
            field: RowsField.id,
            headerName: "Delete",
            width: 60,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (

                <div className="flex justify-evenly" ><h6> {row.id}</h6>
                    <strong>
                        <FontAwesomeIcon
                            color="red"
                            onClick={() => handleDeleteRow(row.id)}
                            icon={faTrashCan}
                            className={isOrdClose ? 'disabled' : ""}
                        ></FontAwesomeIcon>
                    </strong>
                </div>
            ),
        },
        {
            field: RowsField.itemCode,
            headerName: "Item Code",
            width: 80,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>
                {row.itemCode}
            </div>)
        },
        {
            field: RowsField.itemName,
            headerName: "Item Name",
            width: 260,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div onMouseDown={handleWrapperMouseDown}>
                    <Autocomplete
                        isRequired
                        size="sm"
                        id={RowsField.itemName}
                        eventResizeFeature={true}
                        selectionMode="single"
                        showScrollIndicators={false}
                        placeholder="--Select--"
                        // fullWidth={true}
                        // autoFocus={true}
                        //className="max-w-23"
                        isClearable={false}
                        isVirtualized
                        isLoading={isLoadingData}
                        variant="flat"
                        color="success"
                        menuTrigger={menuTrigger}
                        isReadOnly={isOrdUpLock || isOrdClose ? true : false}
                        defaultItems={
                            masterData && masterData?.itemMaster ? masterData.itemMaster : []
                        }
                        onSelectionChange={(e) =>
                            handleAutoCompleteChange(e, row.id, "")
                        }
                        onOpenChange={handleOpenChange}
                        ref={inputRef}
                        //onChange={handleFormSelectionChange}
                        selectedKey={row.itemCode}
                    >
                        {(item) => (
                            <AutocompleteItem
                                classNames={{
                                    base: "min-h-[24px] py-1",
                                    title: "text-xs whitespace-normal break-words",
                                }}
                                key={item.Item_Code}
                            >
                                {item.Item_Desc + "(" + item.Item_Code + ")"}
                            </AutocompleteItem>
                        )}
                    </Autocomplete>

                </div>
            ),
        },

        {
            field: RowsField.designNo,
            headerName: "Design No",
            width: 130,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.designNo, "text", false, "Design No", false, "", ""),

        },
        {
            field: RowsField.compName,
            headerName: "Comp Name",
            width: 100,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>
                {row.compName}
            </div>)

        },
        {
            field: RowsField.packSize,
            headerName: "Pack Size",
            width: 90,
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {row.packSize}
                </div>
            ),
        },
        {
            field: RowsField.itemDetail,
            headerName: "Item Detail",
            width: 150,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.itemDetail, "text", false, "Item Detail", false, "", ""),
        },

        {
            field: RowsField.unit,
            headerName: "Unit",
            width: appType == ENUM_APP_TYPE.TEXTTILE ? 70 : 130,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="text-center">
                    {appType == ENUM_APP_TYPE.TEXTTILE ?
                        row.unit :
                        <Select
                            id={RowsField.unit}
                            name={RowsField.unit}
                            items={ENUM_UNIT}
                            size="sm"
                            className="mt-1"
                            placeholder="Select"
                            color="success"
                            onChange={(e) => handleInputChange(row.id, e)}
                            selectedKeys={[String(row[RowsField.unit])]}
                            isDisabled={isOrdClose ? true : false}
                        >
                            {(item) => {
                                return (
                                    <SelectItem key={item.value} >{item.value}</SelectItem>

                                )
                            }}
                        </Select>}
                </div>)
        },
        {
            field: RowsField.qtyPer,
            headerName: "Qty On",
            width: 125,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            hide: false,
            renderCell: ({ row }) =>
                <Select
                    id={RowsField.qtyPer}
                    name={RowsField.qtyPer}
                    items={ENUM_QTY_ON}
                    size="sm"
                    className="mt-1"
                    placeholder="Select"
                    color="warning"
                    onChange={(e) => handleSelectChange(row.id - 1, e)}
                    selectedKeys={[String(row[RowsField.qtyPer])]}
                    isDisabled={isOrdClose ? true : false}
                    classNames={{
                                trigger: "text-xs",
                                popoverContent: "text-xs",
                            }}

                >
                    {(item) => {
                        return (
                            <SelectItem
                                classNames={{
                                    base: "min-h-[24px] py-1",
                                    title: "text-xs whitespace-normal break-words",
                                }}
                                key={item.value} >{item.value}</SelectItem>

                        )
                    }}
                </Select>
        },
       
        {
            field: RowsField.oChallan,
            headerName: "Challan",
            width: 85,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.oChallan, "number", row.qtyPer == 'CHALLAN' ? false : true, "", true, "", ""),
        },
         {
            field: RowsField.oMtrRange,
            headerName: "Range",
            width: 100,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.oMtrRange, "text", row.qtyPer == 'CHALLAN' ? false : true, "Range", false, "", ""),
        },
        {
            field: RowsField.pcs,
            headerName: "Pcs",
            width: 100,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.pcs, "number", false, "", false, "flat", "warning"),
        },
        {
            field: RowsField.meter,
            headerName: "Meter",
            width: 110,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                // (<div>
                //     {row.unit && row.unit != "" ? row.unit.toLowerCase() == "mtr" ?
                renderInputCell(row, RowsField.meter, "number",
                    // row.unit && row.unit != "" ? row.unit.toLowerCase() == "kgs" ? true : false : false
                    false
                    , "", false, "flat", "warning")
            // : row[RowsField.meter] : row[RowsField.meter]}

            // </div>)

        },
        {
            field: RowsField.weight,
            headerName: "Weight",
            width: 110,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.weight, "number",
                    // row.unit && row.unit != "" ? row.unit.toLowerCase() == "mtr" ? true : false : false, false
                    false
                    , "", false, "flat", "warning"),
            // (<div>
            //     {row.unit && row.unit != "" ? row.unit.toLowerCase() == "kgs" ?
            //         renderInputCell(row, RowsField.weight, "number",
            //             // row.unit && row.unit != "" ? row.unit.toLowerCase() == "kgs" ? true : false : false
            //             false
            //             , "", false, "", "") : row[RowsField.weight] : row[RowsField.weight]}

            // </div>)

        },
        {
            field: RowsField.rate,
            headerName: "Rate",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.rate, "number", false, "", false, "flat", "warning"),
        },
        {
            field: RowsField.amount,
            headerName: "Amount",
            width: 130,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.amount, "number", true, "", false, "flat", "danger")
        },


        {
            field: RowsField.discPer,
            headerName: "Disc %",
            width: 85,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.discPer, "number", false, "", false, "", ""),
        },
        {
            field: RowsField.stopDate,
            headerName: "Stop Date",
            width: 180,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label={""}
                            disabled={isOrdClose ? true : false}
                            views={["day", "month", "year"]}
                            format="DD/MM/YYYY"
                            value={
                                row.stopDate
                                    ? dayjs(row.stopDate)
                                    : row.stopDate
                            }
                            onChange={(newValue) => handleDateChange(newValue, row.id - 1, RowsField.stopDate)}
                            className="w-full mt-1"
                            slotProps={{
                                textField: { size: "small", required: false },
                            }}
                        />
                    </LocalizationProvider></div>)
        },
        {
            field: RowsField.orderCloseDate,
            headerName: "Order Close Date",
            width: 180,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label={""}
                            disabled={isOrdClose ? true : false}
                            views={["day", "month", "year"]}
                            format="DD/MM/YYYY"
                            value={
                                row.orderCloseDate
                                    ? dayjs(row.orderCloseDate)
                                    : row.orderCloseDate
                            }
                            onChange={(newValue) => handleDateChange(newValue, row.id - 1, RowsField.orderCloseDate)}
                            className="w-full mt-1"
                            slotProps={{
                                textField: { size: "small", required: false },
                            }}
                        />
                    </LocalizationProvider></div>)
        },

    ]

    const formField = {
        orderNo: "orderNo",
        orderDate: "orderDate",
        partyName: "partyName",
        partyId: "partyId",
        address: "address",
        mobileNo: "mobileNo",
        partyOrderNo: "partyOrderNo",
        partyOrderDate: "partyOrderDate",
        paymentTerm: "paymentTerm",
        remark: "remark",
        salesPerson: "salesPerson",
        lacId: "lacId",
        brokerId: "brokerId",
        dueDays: "dueDays"
        //brokerName:"brokerName"


    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.orderDate || key == formField.partyOrderDate)
            acc[key] = new Date()
        else if (key == formField.dueDays)
            acc[key] = 0
        else acc[key] = ""
        return acc
    }, {})

    const [formData, setFormData] = useState({
        ...emptyFormField
    })
    const inputBoxes = {
        Row1: [{
            id: formField.orderNo,
            name: formField.orderNo,
            placeholder: "Order No",
            type: ENUM_INPUT_TYPE.text,
            size: "sm",
            label: "",
            isrequired: true,

        },
        {
            id: formField.orderDate,
            name: formField.orderDate,
            placeholder: "Order Date",
            type: ENUM_INPUT_TYPE.date,
            size: "sm",
            label: "",
            isrequired: true,

        }]
        ,
        Row2: [{
            id: formField.partyId,
            name: formField.partyId,
            placeholder: "Party Name",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: masterData && masterData?.pitemMaster ? masterData?.pitemMaster : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: true,

        }],
        Row3: [{
            id: formField.address,
            name: formField.address,
            placeholder: "Address",
            type: ENUM_INPUT_TYPE.text,
            size: "sm",
            label: "",
            isrequired: false,

        },
        {
            id: formField.mobileNo,
            name: formField.mobileNo,
            placeholder: "Mobile No",
            type: ENUM_INPUT_TYPE.number,
            size: "sm",
            label: "",
            isrequired: false,

        }
        ],
        Row4: [{
            id: formField.partyOrderNo,
            name: formField.partyOrderNo,
            placeholder: "Party Order No",
            type: ENUM_INPUT_TYPE.text,
            size: "sm",
            label: "",
            isrequired: false,

        },
        {
            id: formField.partyOrderDate,
            name: formField.partyOrderDate,
            placeholder: "Party Order Date",
            type: ENUM_INPUT_TYPE.date,
            size: "sm",
            label: "",
            isrequired: false,

        }
        ],
        Row5: [
            {
                id: formField.dueDays,
                name: formField.dueDays,
                placeholder: "Due Days",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
           
            {
                id: formField.lacId,
                name: formField.lacId,
                placeholder: "Location",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: masterData && masterData?.lacMaster ? masterData?.lacMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: false,

            },
        ],
        Row6: [{
            id: formField.salesPerson,
            name: formField.salesPerson,
            placeholder: "Sales Person",
            type: ENUM_INPUT_TYPE.select,
            size: "sm",
            label: "",
            data: masterData && masterData?.empMaster ? masterData?.empMaster : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: false,

        },
        {
            id: formField.brokerId,
            name: formField.brokerId,
            placeholder: "Broker",
            type: ENUM_INPUT_TYPE.select,
            size: "sm",
            label: "",
            data: masterData && masterData?.brokerMaster ? masterData?.brokerMaster : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: false,

        },
        ],
        Row7: [
            {
                id: formField.remark,
                name: formField.remark,
                placeholder: "Remark",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
             {
                id: formField.paymentTerm,
                name: formField.paymentTerm,
                placeholder: "Payment Term",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
        ]
    }

    const handleChange = (e) => {

        const { value, name } = e.target;

        setFormData({ ...formData, [name]: value })

    }

    const handleAutoCompleteChange = (value, rowid, name) => {
        if (name == formField.partyId) {
            const curItemIndex = masterData.pitemMaster.findIndex((ele) => ele.Party_Id == value)
            //console.log(curItemIndex,masterData.pitemMaster)
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
                address: curItemIndex > 0 ? masterData.pitemMaster[curItemIndex].Party_Address : "",
                mobileNo: curItemIndex > 0 ? masterData.pitemMaster[curItemIndex].Party_ContectNo : "",
            }));
        }
        else {
            if (!value) {
                // Selection cleared
                const input = inputRef.current?.querySelector("input");
                input?.blur(); // Close keyboard
            }
            const tempdata = masterData.itemMaster
            const itemData = tempdata.filter((ele) => ele.Item_Code == value)
            const index = rows.findIndex((ele) => ele.id == rowid)

            if (itemData && itemData.length > 0) {
                let newRow = [...rows]
                newRow[index].itemCode = itemData[0].Item_Code
                newRow[index].itemName = itemData[0].Item_Desc
                newRow[index].packSize = itemData[0].Pack_Size
                newRow[index].unit = itemData[0]?.Item_Unit && itemData[0]?.Item_Unit != "" ? itemData[0]?.Item_Unit.toUpperCase() : ""
                newRow[index].compName = itemData[0].Made
                // update amount if unit change on item change
                // let t_unit = itemData[0]?.Item_Unit && itemData[0]?.Item_Unit != "" ? itemData[0]?.Item_Unit.toLowerCase() : ""
                // if (['kgs', 'crt', 'ton'].includes(t_unit))
                //     newRow[index].meter = 0;
                // else if (['mtr', 'ltr', 'sqf', 'sqm'].includes(t_unit))
                //     newRow[index].weight = 0;
                const Amount = funCalAmount(itemData[0].Item_Unit, newRow[index].meter, newRow[index].weight, newRow[index].pcs, newRow[index].rate)
                newRow[index].amount = Amount
                let t_discper = parseFloat(newRow[index].discPer)
                if (parseFloat(Amount) > 0 && parseFloat(t_discper) > 0)
                    newRow[index].discAmt = ((parseFloat(Amount) * parseFloat(t_discper)) / 100).toFixed(2)
                //end
                setRows(newRow)
            }
        }
    }

    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        // Validate username
        if (formData.orderNo?.trim() == "") {
            newErrors[formField.orderNo] = "Order No is required"
        }

        if (formData[formField.partyId] == null || formData[formField.partyId]?.trim() == "" || formData[formField.partyId] == "0") {
            newErrors[formField.partyId] = "Party Name is required"
        }

        if (formData[formField.orderDate] == "" || formData[formField.orderDate] == null || formData[formField.orderDate] == "Invalid Date") {
            newErrors[formField.orderDate] = "required"
        }
        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }
    const funSubmitOrder = () => {
        funInUpSalesOrder({
            data: {
                order_list: rows,
                deleteditem_list: deletedItemRows,
                comp_code: compCode.join(","),
                rec_status: !isNewEntry ? 1 : 2,
                login_userid: user.username,
                order_no: String(formData.orderNo),
                order_date: formData.orderDate,
                party_Id: formData.partyId,
                bill_type: 'S',
                party_orderdate: formData.partyOrderDate != 'Invalid Date' && formData.partyOrderDate != '' ? formData.partyOrderDate : null,
                party_address: formData.address,
                party_orderno: formData.partyOrderNo,
                remark: formData.remark,
                trade_of: 'C',
                contect_no: formData.mobileNo,
                ord_status: 0,
                pay_term: formData.paymentTerm,
                due_days: formData?.dueDays || 0,
                lac_id: formData.lacId,
                spac_id: formData.salesPerson,
                broker_id: formData.brokerId
            }
        })
    }

    useEffect(() => {
        validateForm();
    }, [formData])

    const handleSubmit = (e) => {

        e.preventDefault()

        const validate_form = validateForm()
        if (rows && rows?.length > 0) {
            if (!ValidateGrid() && validate_form) {
                if (isMobile)
                    setShowConfirm(true)
                else
                    funSubmitOrder()

                //funSubmitOrder()
                // funInUpSalesOrder({
                //     data: {
                //         order_list: rows,
                //         deleteditem_list: deletedItemRows,
                //         comp_code: compCode.join(","),
                //         rec_status: !isNewEntry ? 1 : 2,
                //         login_userid: user.username,
                //         order_no: String(formData.orderNo),
                //         order_date: formData.orderDate,
                //         party_Id: formData.partyId,
                //         bill_type: 'S',
                //         party_orderdate: formData.partyOrderDate != 'Invalid Date' && formData.partyOrderDate != '' ? formData.partyOrderDate : null,
                //         party_address: formData.address,
                //         party_orderno: formData.partyOrderNo,
                //         remark: formData.remark,
                //         trade_of: 'C',
                //         contect_no: formData.mobileNo,
                //         ord_status: 0,
                //         pay_term: formData.paymentTerm,
                //         lac_id: formData.lacId,
                //         spac_id: formData.salesPerson,
                //         broker_id: formData.brokerId
                //     }
                // })
            }
            else {
                toast.error("Entry Qty ON or Ochallan data ! ", {
                    position: "top-center"
                })
            }
        }
        else {
            toast.error("Add Atleast One Item ! ", {
                position: "top-center"
            })
        }


    }
    const [showConfirm, setShowConfirm] = useState(false);
    const confirmSubmit = () => {
        setShowConfirm(false);
        funSubmitOrder(); // your real submit logic
    };
    const handleAddRow = () => {
        const newRowsId = rows.length + 1
        const newRow = { id: rows.length + 1, ...initialRow }
        setRows([...rows, newRow])
        setTimeout(() => {

            const gridScroller = gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
            if (gridScroller) {
                gridScroller.scrollLeft = 0; // Scroll to the left
            }
        }, 250)
        setTimeout(() => {

            const firstCell = gridContainerRef.current?.querySelector(
                `[data-id='${newRowsId}'] [data-field="id"]`
            );
            if (firstCell) {
                firstCell.focus();
            }
        }, 500);
    }

    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
        if (detail && detail?.itemDetail && detail?.itemDetail?.length > 0) {

            gridData = detail?.itemDetail.map((item, i) => {
                return {
                    id: ++i,
                    itemCode: item?.Item_Code ?? '',
                    designNo: item?.DesignNo ?? "",
                    itemName: item?.Item_Desc ?? "",
                    compName: item?.comp_name ?? "",
                    packSize: item?.Pack_Size ?? "",
                    itemDetail: item?.Item_Detail ?? "",
                    unit: item?.item_unit && item?.item_unit != "" ? item?.item_unit.toUpperCase() : "",// item?.item_unit ?? "",
                    rate: item?.Rate ?? 0,
                    amount: item?.Amount ?? 0,
                    discPer: item?.DiscPer ?? 0,
                    discAmt: item?.DiscAmt ?? 0,
                    pcs: item?.Pcs ?? 0,
                    meter: item?.Meter ?? 0,
                    weight: item?.weight ?? 0,
                    srNo: item?.SrNo ?? 0,
                    stopDate: item?.Stop_Date ?? null,
                    orderCloseDate: item?.Close_Date ?? null,
                    orderNo: item?.Ord_No ?? '',
                    qtyPer: item?.QtyPer ?? '',
                    oChallan: item?.Ochallan ?? 0,
                    oMtrRange: item?.OMTRRANGE ?? 0
                }
            })
        }
    }

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            setRows(gridData)
            if (detail &&
                !isNewEntry &&
                detail?.orderDetail &&
                detail?.orderDetail.length > 0) {
                if (detail?.orderDetail[0].closeflg)
                    setIsOrdClose(true)
                else
                    setIsOrdClose(false)
                if (detail?.orderDetail[0].dtaka > 0 || detail?.orderDetail[0].dmeter > 0 || detail?.orderDetail[0].dweight > 0) {
                    setIsOrdUpLock(true)
                }
                else
                    setIsOrdUpLock(false)
            }
            if (detail &&
                !isNewEntry &&
                detail?.itemDetail &&
                detail?.itemDetail.length > 0 &&
                detail?.itemData &&
                detail?.itemData.length > 0) {
                setFormData({

                    compCode: detail?.itemData[0]?.CompCode ? detail?.itemData[0]?.CompCode : "",
                    orderNo: detail?.itemData[0]?.Ord_No ? detail?.itemData[0]?.Ord_No : "",
                    orderDate: detail?.itemData[0]?.Ord_Date ? new Date(detail?.itemData[0]?.Ord_Date).toISOString().split('T')[0] : null,
                    partyId: detail?.itemData[0]?.PAc_Id ? detail?.itemData[0]?.PAc_Id : "",
                    partyName: detail?.itemData[0]?.PartyName ? detail?.itemData[0]?.PartyName : "",
                    partyOrderDate: detail?.itemData[0]?.Pord_Date != '' &&
                        detail?.itemData[0]?.Pord_Date != '1900-01-01T00:00:00.000Z'
                        ? new Date(detail?.itemData[0]?.Pord_Date).toISOString().split("T")[0] : null,
                    address: detail?.itemData[0]?.PAddress ? detail?.itemData[0]?.PAddress : "",
                    partyOrderNo: detail?.itemData[0]?.POrd_No ? detail?.itemData[0]?.POrd_No : "",
                    remark: detail?.itemData[0]?.Remark ? detail?.itemData[0]?.Remark : "",
                    //trade_of: detail?.TradeOf ?detail?.:"",,
                    mobileNo: detail?.itemData[0]?.PContentNo ? detail?.itemData[0]?.PContentNo : "",
                    paymentTerm: detail?.itemData[0]?.Pay_term ? detail?.itemData[0]?.Pay_term : "",
                    lacId: detail?.itemData[0]?.LAc_ID ? detail?.itemData[0]?.LAc_ID : "",
                    salesPerson: detail?.itemData[0]?.Spac_Id ? detail?.itemData[0]?.Spac_Id : "",
                    brokerId: detail?.itemData[0]?.Broker_Id ? detail?.itemData[0]?.Broker_Id : "",
                    dueDays: detail?.itemData[0]?.Due_Days || 0,

                })
            }
        }
    }, [detail])

    const handleCellKeyDown = (params, event) => {
        if (event.key === 'Tab') {
            const { field, id } = params;
            const currentRowIndex = rows.findIndex(row => row.id === id);
            const colIndex = columns.findIndex(col => col.field === field);

            const isLastCol = colIndex === columns.length - 1;

            if (isLastCol) {
                event.preventDefault();

                const nextRowIndex = currentRowIndex + 1;

                if (nextRowIndex < rows.length) {
                    const nextRowId = rows[nextRowIndex].id;
                    const nextField = columns[0].field;
                    setTimeout(() => {
                        const gridScroller = gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
                        if (gridScroller) {
                            gridScroller.scrollLeft = 0; // Scroll to the left
                        }
                    }, 50)
                    setTimeout(() => {

                        const firstCell = gridContainerRef.current?.querySelector(
                            `[data-id="${nextRowId}"] [data-field="id"]`
                        );
                        if (firstCell) {
                            firstCell.focus();
                        }
                        // gridContainerRef.current.selectCell({ id: nextRowId, field: nextField });
                    }, 0);
                }
            }
        }
    };

    if (isError || isErrorDetail) {
        return <ErrorCard />
    }
    if (isPending || isLoadingDetail) {
        return <LoadingCard />
    }
    return (
        <div>
            <MainContainer pageName={`${isNewEntry ? "New" : "Update"} Sale Order Entry
            `}
                breadcrumbs={["Transaction", "Sale Order Entry"]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }} >
                <Card shadow="sm" className="mb-3 w-full">
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        {showConfirm && (
                            <div className="z-[99] fixed inset-0 text-xs bg-blue-100 bg-opacity-50 flex items-center justify-center">
                                <div className="bg-white p-4 rounded shadow-md w-11/12 max-w-sm">
                                    <p className="mb-4">Are you sure you want to submit this order?</p>
                                    <div className="flex justify-end gap-2">
                                        <button className="bg-red-500 text-white px-4 py-1 rounded" onClick={() => setShowConfirm(false)}>Cancel</button>
                                        <button onClick={confirmSubmit} className="bg-blue-500 text-white px-4 py-1 rounded">
                                            Yes, Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                        <CardBody>
                            <div>
                                {
                                    Object.keys(inputBoxes).map((key, ind) => (
                                        <div key={key + ind}>
                                            <div className={` ${isMobile ? 'flex-wrap' : ''}  align-baseline  flex gap-4 items-baseline mb-2 `}>
                                                {
                                                    inputBoxes[key].map((item, indx) =>
                                                        item.type == ENUM_INPUT_TYPE.select ? (
                                                            <Select
                                                                name={item?.name}
                                                                placeholder="--select--"
                                                                label={item?.placeholder}
                                                                labelPlacement="outside"
                                                                selectionMode="single"
                                                                isVirtualized
                                                                isRequired={item.isrequired}
                                                                value={formData[item.name]}
                                                                items={item.data ? item.data : []}
                                                                variant="flat"
                                                                color={item.name == formField.salesPerson || item.name == formField.brokerId ? "primary" : "warning"}
                                                                onChange={handleChange}
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                                selectedKeys={[String(formData[item.name])]}
                                                            >
                                                                {(list) => {
                                                                    return (
                                                                        <SelectItem key={list[item.itemkey]}>
                                                                            {list[item.itemvalue]}
                                                                        </SelectItem>
                                                                    );
                                                                }}
                                                            </Select>
                                                        ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (

                                                            <Autocomplete
                                                                size="md"
                                                                name={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                label={item?.placeholder}
                                                                eventResizeFeature={true}
                                                                selectionMode="single"
                                                                showScrollIndicators={true}
                                                                labelPlacement={"outside"}
                                                                placeholder={item.placeholder}
                                                                isRequired={item.isrequired}
                                                                isLoading={isLoadingData}
                                                                className="max-w-23"
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                                isClearable={false}
                                                                isVirtualized
                                                                defaultItems={
                                                                    item.data ? item.data : []
                                                                }
                                                                onSelectionChange={(e) =>
                                                                    handleAutoCompleteChange(e, "", item.name)
                                                                }
                                                                readOnly={isOrdUpLock ? true : false}
                                                                color={item.name == formField.partyId ? "danger" : "primary"}
                                                                selectedKey={formData[item.name]}
                                                            >
                                                                {(list) => (
                                                                    <AutocompleteItem

                                                                        key={list[item.itemkey]}
                                                                    >
                                                                        {list[item.itemvalue]}
                                                                    </AutocompleteItem>
                                                                )}
                                                            </Autocomplete>
                                                        ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                            <div className=" w-full flex items-center">
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DatePicker
                                                                        label={item.placeholder}
                                                                        views={["day", "month", "year"]}
                                                                        format="DD/MM/YYYY"
                                                                        value={
                                                                            formData[item.name]
                                                                                ? dayjs(formData[item.name])
                                                                                : formData[item.name]
                                                                        }
                                                                        onChange={(newValue) => {
                                                                            setFormData((prev) => {
                                                                                return {
                                                                                    ...prev,
                                                                                    [item.name]:
                                                                                        dayjs(newValue).format("YYYY-MM-DD"),

                                                                                };
                                                                            });
                                                                        }}
                                                                        //isRequired={item.required}
                                                                        className="w-full "
                                                                        slotProps={{
                                                                            textField: { size: "small", error: errors[item.name], required: item.name == formField.orderDate ? true : false },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>

                                                            </div>
                                                        ) : (
                                                            <Input
                                                                type={item.type}
                                                                name={item.name}
                                                                //aria-label={item.placeholder}
                                                                placeholder={item.placeholder}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                label={item.placeholder}
                                                                labelPlacement="outside"
                                                                isRequired={item.isrequired}
                                                                value={formData[item.name]}
                                                                variant="bordered"
                                                                onChange={handleChange}
                                                                readOnly={item.name == formField.orderNo ? true : false}
                                                                size={"md"}
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                            ></Input>
                                                        )
                                                    )
                                                }
                                            </div>
                                        </div>

                                    ))
                                }

                                {/* dynamic grid section */}
                                <div >
                                    <Button size="sm" color="success" className="text-white" startContent={<FontAwesomeIcon color="white" icon={faPlus} />} variant="shadow" onPress={handleAddRow}>
                                        ADD ITEM
                                    </Button>

                                    {rows && rows?.length > 0 ? (
                                        <Box ref={gridContainerRef}
                                            sx={{
                                                height: rows.length > 10 ? 400 : 'auto',
                                                width: '100%',
                                                overflowX: 'auto',
                                                overflowY: 'auto',
                                                WebkitOverflowScrolling: 'touch',
                                                touchAction: 'manipulation',
                                                maxHeight: 'calc(100dvh - 150px)',
                                            }} >
                                            {/* // style={{ height: 50 + Number(rows.length * 51), overflow: "visible" }}> */}
                                            <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                editMode="row"
                                                hideFooterPagination={true}
                                                hideFooter={true}
                                                columnHeaderHeight={35}
                                                rowHeight={50}
                                                // virtualizeColumnsWithAutoRowHeight={true}
                                                disableColumnSorting={true}
                                                disableColumnMenu={true}
                                                onCellKeyDown={handleCellKeyDown}
                                                getRowClassName={(params) => {
                                                    return 'row-class';
                                                }}
                                                sx={{
                                                    '& .MuiDataGrid-columnHeaders': {
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1, // Make sure the headers are above the rows when scrolling
                                                    },
                                                    '& .row-class': {
                                                        fontSize: "12px",
                                                    },

                                                }}
                                                columnVisibilityModel={appType == ENUM_APP_TYPE.TEXTTILE ? {
                                                    oChallan: modeSettingParams[RowsField.oChallan],
                                                    qtyPer: modeSettingParams[RowsField.qtyPer],
                                                    packSize: false,
                                                    compName: false,
                                                    designNo: true,
                                                } : {
                                                    oChallan: false,
                                                    qtyPer: false,
                                                    designNo: false,
                                                    packSize: modeSettingParams[RowsField.packSize],
                                                    compName: modeSettingParams[RowsField.compName]
                                                }}
                                            />
                                        </Box>
                                    ) : (
                                        ""
                                    )}
                                </div>
                                <div className="p-5">

                                </div>

                                <div className="justify-center flex gap-5 mt-20">
                                    <Button
                                        color="primary"
                                        type="submit"
                                        size="md"
                                        variant="shadow"
                                        startContent={<FontAwesomeIcon icon={faSave} />}
                                    >
                                        Submit
                                    </Button>
                                    <Button
                                        color="danger"
                                        variant="shadow"
                                        size="md"
                                        onPress={handleClickPrev}
                                        startContent={<FontAwesomeIcon icon={faCancel} />}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </CardBody>
                    </form>
                </Card>


            </MainContainer>

        </div >
    )

}
export default CreateSalesOrder